import React from 'react';
import 'dayjs/locale/pt-br';
import { InfoIncon } from '../info';
import { Container } from './styled';
import { useRouter } from 'next/router';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ConsideracaoIcon } from '../consideracao';
import { ptBR } from '@mui/x-date-pickers/locales';
import { Controller, Control } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ConsiderationModal } from '../../Forms/ConsiderationModal';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

interface IProps {
  errors: any;
  mt?: number;
  name: string;
  label: string;
  views?: any[];
  width?: string;
  tooltip?: string;
  formName?: string;
  defaultValue?: any;
  required?: boolean;
  commentTittle?: string;
  control: Control<any, any>
}

const brazilianLocale = ptBR.components.MuiLocalizationProvider.defaultProps.localeText;

const CustomDatePicker = styled(DatePicker)(() => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#fff',
    height: '38px',
  },
  '& .MuiInputBase-input': {
    height: '100%',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#DEE2E6 !important'
  },
}));

const dayOfWeekFormatter = (day: string) => {
  switch (day) {
    case 'Do':
      return 'D';
    case '2ª':
      return 'S';
    case '3ª':
      return 'T';
    case '4ª':
      return 'Q';
    case '5ª':
      return 'Q';
    case '6ª':
      return 'S';
    case 'Sá':
      return 'S';
    default:
      return day;
  }
};

export const DatePickerElaboration: React.FC<IProps> = ({
  name,
  label,
  views,
  errors,
  tooltip,
  control,
  formName,
  required,
  defaultValue,
  commentTittle,
}) => {
  const [filledValue, setFilledValue] = React.useState({} as Dayjs);
  React.useEffect(() => {
    setFilledValue(defaultValue)
  }, [defaultValue])

  return (
    <Container>
      <div className="title_wrapper_datepicker">
        <ToolTipWrapper
          name={name}
          label={label}
          tooltip={tooltip}
          formName={formName}
          required={required}
          commentTittle={commentTittle}
        />
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br" localeText={brazilianLocale}>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => {
            return (
              <CustomDatePicker
                views={views}
                minDate={dayjs()}
                value={defaultValue}
                onChange={(date) => {
                  if (date) {  // Apenas atualiza se a data for válida
                    field.onChange(date);
                    setFilledValue(date as any);
                  }
                }}
                dayOfWeekFormatter={dayOfWeekFormatter}
                sx={{
                  '& .MuiInputBase-root': {
                    color: !!filledValue && Object.values(filledValue).length > 0 ? '#000' : '#DEE2E6'
                  }
                }}
              />
            )
          }}
        />
      </LocalizationProvider>
      {errors && (
        <div className="error_wrapper" style={{ marginTop: '28px;' }}>
          {errors.hasOwnProperty('meta') && (
            <span>{errors[name]?.message}</span>
          )}
        </div>
      )}
    </Container>
  );
}

type TooltipWrapperProps = {
  name?: string,
  label?: string,
  register?: any,
  value?: string,
  tooltip?: string,
  formName?: string,
  required?: boolean,
  commentTittle?: string;
}

import { tooltipClasses } from '@mui/material/Tooltip';
import dayjs, { Dayjs } from 'dayjs';

const LightTooltip = styled(({ className, ...props }: any) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.withe,
    backgroundColor: theme.palette.common.white,
  },
}));

const ToolTipWrapper = ({
  name,
  value,
  label,
  tooltip,
  required,
  register,
  formName,
  commentTittle
}: TooltipWrapperProps) => {

  const router = useRouter();
  const [epl, setEpl] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!router.isReady) return
    if (!router.query.id) return

    setEpl(router.asPath.includes('epl') && router.asPath.includes('dashboard/aprovacao_planos'));
  }, [router.asPath, router.isReady, router.query.id])

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label style={{ display: 'flex', alignItems: 'center' }} className="interFont">
        <p>{label}</p>
        <span>
          {required ? '*' : ''}
        </span>
      </label>
      {!epl && (
        <>
          {tooltip && (
            <LightTooltip title={tooltip}>
              <div>
                <InfoIncon />
              </div>
            </LightTooltip>
          )}
        </>
      )}
      {epl && (
        <CondiserationWrapper
          name={name}
          label={label}
          value={value}
          formName={formName}
          register={register}
          commentTittle={commentTittle}
        />
      )}
    </div>
  )

}

const CondiserationWrapper = ({
  name,
  label,
  value,
  formName,
  register,
  commentTittle,
}: {
  name?: string,
  label?: string,
  value?: string,
  register?: any,
  formName?: string,
  commentTittle?: string;
}) => {

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <>
      <a className="consideration-modal" onClick={() => { setOpen(true) }}>
        <ConsideracaoIcon />
      </a>
      <ConsiderationModal
        open={open}
        name={name}
        label={label}
        value={value}
        formName={formName}
        register={register}
        handleClose={handleClose}
        commentTittle={commentTittle}
      />
    </>
  )
}
